import { createTheme } from '@mui/material/styles';

const socialLinkStyles = `
  .social-link {
    text-decoration: none;
    color: inherit;
    transition: color 0.3s ease;
  }
  .social-link:hover {
    color: #FFB703;
  }
`;

export const theme = createTheme({
  palette: {
    primary: { main: '#023047', light: '#FFF', dark: '#023047', contrastText: '#FFFFFF' },
    secondary: { main: '#FFB703', dark: '#FB8500', contrastText: '#023047' },
    background: { default: '#F5F5F5', paper: '#FFFFFF' },
    text: { primary: '#023047', secondary: '#023047' },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 600, color: '#023047' },
    h6: { fontWeight: 500 },
  },
  components: {
    MuiPaper: { styleOverrides: { root: { boxShadow: '0 3px 5px 2px rgba(0, 0, 0, .1)' } } },
    MuiAppBar: { styleOverrides: { root: { backgroundColor: '#023047' } } },
    MuiFormLabel: { styleOverrides: { root: { fontSize: '0.875rem' } } },
    MuiCssBaseline: { styleOverrides: socialLinkStyles },
  },
});
